import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=661db306&scoped=true"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=661db306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661db306",
  null
  
)

export default component.exports